export default "__VITE_ASSET__DgJDrnSw__"